import * as orderhistory from '../actions/order-history.actions';

import { RequestWrap } from '../../core/models/request-wrap'
import { OrderHistoryLine } from '../models/orderhistoryline';

import { getPagesCount } from '../../shared/utils/get-pages-count';

export interface State {
  loading: boolean
  expanding: boolean
  error: any
  currentPage: number
  nextPage: number
  totalPages: number
  total: number
  orderhistorylines: OrderHistoryLine[]
}

export const initialState: State = {
  loading: false,
  expanding: false,
  error: null,
  currentPage: 1,
  nextPage: 2,
  totalPages: 1,
  total: 0,
  orderhistorylines: [] as OrderHistoryLine[]
}

export function reducer(state = initialState, action: orderhistory.OrderHistoryActions): State {
  let wrap: RequestWrap<OrderHistoryLine[]>

  switch (action.type) {
    case orderhistory.OrderHistoryActionTypes.LoadOrderHistoryLines:
      return {
        ...state,
        loading: true
      }

    case orderhistory.OrderHistoryActionTypes.LoadOrderHistoryLinesSuccess:
      wrap = action.payload

      return {
        ...state,
        loading: false,
        error: null,
        currentPage: 1,
        nextPage: 2,
        totalPages: getPagesCount(wrap.totalCount),
        total: wrap.totalCount,
        orderhistorylines: wrap.results
      }

    case orderhistory.OrderHistoryActionTypes.LoadOrderHistoryLinesFailed:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case orderhistory.OrderHistoryActionTypes.LoadOrderHistoryLinesExpand:
      const expanding = state.total !== state.orderhistorylines.length

      return {
        ...state,
        expanding: expanding
      }

    case orderhistory.OrderHistoryActionTypes.LoadOrderHistoryLinesExpandSuccess:
      wrap = action.payload

      return {
        ...state,
        expanding: false,
        orderhistorylines: [...state.orderhistorylines, ...wrap.results],
        currentPage: ++state.currentPage,
        nextPage: ++state.nextPage
      }

    case orderhistory.OrderHistoryActionTypes.LoadOrderHistoryLinesExpandFailed:
      return {
        ...state,
        expanding: false,
        error: action.payload
      }

    case orderhistory.OrderHistoryActionTypes.ResetOrderHistoryLines:
      return Object.assign({}, initialState)

    default:
      return state
  }
}

export const getOrderHistoryLines = (state: State) => state.orderhistorylines
export const getNextPage = (state: State) => state.nextPage
export const getLoading = (state: State) => state.loading
export const getExpanding = (state: State) => state.expanding
export const getError = (state: State) => state.error

